import cn from 'clsx';
import {twMerge} from 'tailwind-merge';

export const twx = (...props: Parameters<typeof cn>) => twMerge(cn(props));
